module.exports = __webpack_public_path__ + "img/icon-question-checkbox_active.34e235a0.svg";